import { Component, ViewChild, Input, Output, EventEmitter,  OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { PagePreloaderComponent } from '../../shared/ui/page-preloader/page-preloader.component';
import { Product, Transfer } from '../shared';
import { LocationPickerComponent } from '../../shared/ui';
import { UserService } from '../../shared/services';
import { IUserInfo, Location, Region,  } from '../../shared/models';
import { Subscription } from 'rxjs/Subscription';
import { TransferService } from './transfer.service';

@Component({
    selector: 'transfer-overview',
    styles: [ require('./transfer-overview.component.scss') ],
    template: require('./transfer-overview.component.pug')
})
export class TransferOverviewComponent implements OnInit {
    @ViewChild(PagePreloaderComponent) preloader;
    @ViewChild(LocationPickerComponent) locationPickerComponent;

    @Input() products: Array<Product>;
    @Input() locationOriginId: number;
    @Input() locationDestinationId: number;
    @Input() destinationEditMode: boolean;
    @Input() allowDestinationEditMode: boolean;
    @Input() originEditMode: boolean;

    @Output() applytransferSuccess = new EventEmitter();
    @Output() applyClose = new EventEmitter();

    fg: FormGroup = new FormGroup({});
    locationOrigin: Location = new Location();
    locationOriginError: boolean;
    regionOrigin: Region = new Region();
    regionsOrigin: Region[];
    locationDestination: Location = new Location();
    regionsDestination: Region[];
    locationDestinationError: boolean;
    regionDestination: Region = new Region();
    title: string = '';
    total: number = 0;
    transferErrorMessage: string = 'Error';
    transferError: boolean = false;
    successMessage: string = 'Success';
    transferSuccess: boolean = false;

    private _user: IUserInfo;
    private _userSubs: Subscription;
    private _isRequestTrasfer: boolean = false;

    constructor(public _userSvc: UserService, public _route: ActivatedRoute, public _transferService: TransferService) {}

    ngOnInit() {
        let that = this;

        let totalProducts = 0;

        that.products.forEach(function(p){
            that.total += +p.quantity;
            totalProducts ++;
        });

        if (totalProducts > 1) {
            that.title = ` Products(Total Qty)`;
        } else {
            that.title = ` ${ that.products[0].name }`;
        }

        that._userSubs = that._userSvc.user$
            .do(user => that._user = user)
            .subscribe(user => that._initializeRegionAndLocation(user));
        that.preloader.hide();
    }

    transfer(e: MouseEvent) {
        e.preventDefault();

        this.preloader.show();

        this.locationOriginError = false;
        this.locationDestinationError = false;

        if (this.originEditMode) {
             let selectionPicker = this.locationPickerComponent.getSelection();
             let region = selectionPicker ? selectionPicker.region : null;
             this.locationOrigin = selectionPicker ? selectionPicker.locations[0] : null;

            if (!region || !this.locationOrigin) {
                this.locationOriginError = true;
                this.preloader.hide();
                return;
            }

        } else if (this.destinationEditMode) {
            let selectionPicker = this.locationPickerComponent.getSelection();
            this.locationDestination = selectionPicker && selectionPicker.locations ? selectionPicker.locations[0] : null;

            if (!this.locationDestination) {
                this.locationDestinationError = true;
                this.preloader.hide();
                return;
            }
        }

        let transfer = new Transfer (this.locationOrigin, this.locationDestination, this.products, this._isRequestTrasfer );
        this._transferService.transfer(transfer)
                .subscribe(res => {
                    this.applytransferSuccess.emit();
                    this.preloader.hide();
                },
                error => {
                    this.transferError = true;
                    this.preloader.hide();
                }
        );
    }

    editDestinationLocation(e: MouseEvent) {
        e.preventDefault();
        this.destinationEditMode = !this.destinationEditMode;
        this.regionsDestination =  this._user.regions.map( region => {
                                                region.locations = region.locations.filter(l => l.id !== this.locationOriginId);
                                                return region;
        });
    }

    close() {
       this.applyClose.emit();
    }

    private _initializeRegionAndLocation(user: IUserInfo) {

        let that = this;

        user.locations.map(location => {

                if (location.id === that.locationDestinationId) {
                    that.locationDestination = location;
                }

                if (location.id === that.locationOriginId) {
                     that.locationOrigin = location;
                }

        });

        user.regions.map(region => {
            region.locations.map(l => {
                if (l.id === that.locationDestinationId) {
                    that.regionDestination = region;
                }
                if (l.id === that.locationOriginId) {
                    that.regionOrigin = region;
                }
            });
        });

        if (this.originEditMode) {
                this._isRequestTrasfer = true;
                let productLocations = that.products[0].locations ? that.products[0].locations.map(l => l.id) : [];
                let regions =  user.regions.map( region => {
                                                region.locations = region.locations
                                                            .filter(l =>
                                                                productLocations.indexOf(l.id) !== -1
                                                                && l.id !== that.locationDestinationId
                                                            );
                                                return region;
                });

                this.regionsOrigin = regions.filter(r => r.locations.length > 0);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/transfer-overview/transfer-overview.component.ts